export default __webpack_public_path__ + "static/media/EcommerceServicesLebenswerkBusinessManagement2.d5de89aa.png";